<template>
  <div class="tab-content flex-direction is-active" id='my-comp-app-recann-list-template'>
    <comp-app-form-btn @showAppForm="handleShowAppForm"></comp-app-form-btn>
    <div class="box-community-top flex-justify-between align-items-center" style="flex-direction: row;">
      <div class="tit">{{ annDetail.ANN_NM }}</div>
      <div class="button-area gap10 mt-0">
        <a href="javascript:void(0)" class="btn btn-secondary btn-md" @click="showAnnPreView" title="공고 미리보기">
          공고 미리보기
        </a>
        <a :href="'/in_appView.do?ANN_NO='+annNo" class="btn btn-secondary btn-md">
          공고 상세보기
        </a>
      </div>
    </div>
    <div class="table-wrap">
      <table class="table-body-only" style="border-top: 1px solid #151515;">
        <caption>공고 정보 표</caption>
        <colgroup class="pc-cell">
          <col style="width: 160px;" />
          <col />
        </colgroup>
        <colgroup class="mo-cell">
          <col style="width: 88px;" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">활동소개</th>
            <td>
              {{ annDetail.INTRO }}
            </td>
          </tr>
          <tr>
            <th scope="row">업·직종</th>
            <td>
              {{ annDetail.OCCUPATION_LABEL }}
            </td>
          </tr>
          <tr>
            <th scope="row">모집규모</th>
            <td>
              {{ annDetail.RCRT_PPL }}명
            </td>
          </tr>
          <tr>
            <th scope="row">모집기간</th>
            <td>
              {{ annDetail.APPDURNG_ST }} {{ annDetail.APPDURNG_ST_TM }}시 ~ {{ annDetail.APPDURNG_ED }} {{ annDetail.APPDURNG_ED_TM }}시
            </td>
          </tr>
          <tr>
            <th scope="row">문의 연락처</th>
            <td>
              {{ annDetail.TEL }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-area tit-type">
      <p class="txt">선택한 참여자의 심사상태</p>
      <div class="input-area">
        <select title="심사상태 선택" v-model="checkChangeStatus">
            <option value=''>심사상태 선택</option>
            <option v-for="(status, index) in resumeStatus" :key="index" :value="status.code">{{ status.name }}</option>
          </select>
      </div>
      <button type="button" class="btn btn-gray btn-xsm" @click="checkChange">일괄변경</button>
    </div>
    <div class="table-wrap border-top-none scroll-table mt-16">
      <div class="no-data" v-if="list.length === 0">신청자 명단 없습니다</div>
      <table class="table-list" style="margin-top: 0;" v-else>
        <caption>공고별 참여자 현황</caption>
        <colgroup>
          <col style="width:56px">
          <col style="width:60px">
          <col style="width:80px">
          <col style="width:120px">
          <col style="width:80px">
          <col style="width:140px">
          <col style="width:150px">
          <col style="width:96px">
          <col style="width:96px">
          <col style="width:96px">
          <col style="width:200px">
        </colgroup>
        <thead>
          <tr>
            <th scope="col">
              <div class="check-wrap tbl-chk chk-all">
                <input type="checkbox" id="chk-all" v-model="allChecked" @click="checkedAll($event.target.checked)" title="chk-all 선택" />
                <label for="chk-all"></label>
              </div>
            </th>
            <th scope="col">연번</th>
            <th scope="col">신청자명</th>
            <th scope="col">생년월일</th>
            <th scope="col">성별</th>
            <th scope="col">연락처</th>
            <th scope="col">이메일</th>
            <th scope="col">경력</th>
            <th scope="col">신청서</th>
            <th scope="col">심사상태</th>
            <th scope="col">심사 상태 변경</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in list" :key="item.APP_NO">
            <td scope="col">
              <div class="check-wrap tbl-chk">
                <input type="checkbox" :id="'item_'+item.APP_NO" v-model="item.checked" @change="checked($event)" title="선택 선택" />
                <label :for="'item_'+item.APP_NO"></label>
              </div>
            </td>
            <td class="text-c">{{ item.rn }}</td>
            <td class="text-c">{{ item.APPLCNT_NM }}</td>
            <td class="text-c">{{ item.BIRTHDE }}</td>
            <td class="text-c">{{ item.GENDER }}</td>
            <td class="text-c">{{ item.HP_1 }}-{{ item.HP_2 }}-{{ item.HP_3 }}</td>
            <td class="text-c">{{ item.EMAIL }}</td>
            <td class="text-c">{{ item.CARR_LABEL }}</td>
            <td class="text-c"><button type="button" class="btn btn-gray btn-xsm" @click="showAppView(item.APP_NO)">보기</button></td>
            <td class="text-c">{{ item.CORM_RST_STAT_LABEL }}</td>
            <td class="text-c">
              <div class="input-area">
                <select title="심사상태 선택" v-model="item.seleteStatus">
                  <option value="" >심사상태 선택</option>
                  <option v-for="(status, index) in resumeStatus" :key="index" :value="status.code">{{ status.name }}</option>
                </select>
                <button type="button" class="btn btn-gray btn-xsm" @click="oneChange(item)">변경</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 페이지네이션 -->
    <pagination :totalPages="paginationInfo.totalPageCount" :currentPage.sync="paginationInfo.currentPageNo" :size="paginationInfo.pageSize" @update:currentPage="handlePageChange"></pagination>
    <app-view :appViewModal="appViewModal" :appNo="appNo" :annKindType="annKindType" @update:appViewModal="appViewModal = $event" :mode="'comp'"></app-view>
    <ann-pre-view :annPreViewModal="annPreViewModal" :annNo="annNo" @update:annPreViewModal="annPreViewModal = $event"></ann-pre-view>
  </div>
</template>

<script>
import Axios from 'axios';
import AppView from '../APP/AppView.vue';
import CompAppFormBtn from '../components/CompAppFormBtn.vue';
import Pagination from '../../shared/Pagination.vue';
import { changeStatue } from '../../../api/compAppRecann';
import AnnPreView from '../../components/AnnPreView.vue';

const resumeStatus = [
  {
    code: 'ING',
    name: '심사중',
  },
  {
    code: 'PASS',
    name: '합격',
  },
  {
    code: 'FAIL',
    name: '불합격',
  },
];


export default {
  name: 'my-comp-app-recann-list-template',
  props: ['annNo'],
  components: {
    AppView,
    CompAppFormBtn,
    Pagination,
    AnnPreView,
  },
  data() {
    return {
      annDetail: {},
      list: [],
      paginationInfo: {},
      pagingParam: {
        pageIndex: 1, // 현재 페이지
      },
      pageIndex: 1,
      totalCnt: 0,
      appViewModal: false,
      annPreViewModal: false,
      annKindType: 'IN',
      appNo: 0,
      resumeStatus,
      allChecked: false,
      checkChangeStatus: '',
      appNos: '',
      changeStatus: '',
    };
  },
  computed: {
    seletedItems() {
      return this.list.filter(item => item.checked).map(item => item.APP_NO);
    },
  },
  watch: {
    appViewModal(newVal) {
        if (!newVal) {
            $('body').removeClass('modal-open');
        }
    }
  },
  methods: {
    checkedAll(checked) {
      this.allChecked = checked;
      this.list.forEach(item => {
        item.checked = this.allChecked;
      });
    },
    checked() {
      const count = this.list.filter(item => item.checked);
      this.allChecked = (count === this.list.length);
    },
    getList() {
      const params = {
        ...this.pagingParam,
        ANN_NO: this.annNo,
      };

      Axios.get('/api/comp/recannAppSituation', { params }).then((response) => {
        this.paginationInfo = response.data.paginationInfo;
        this.annDetail = response.data.annDetail;
        this.totalCnt = response.data.paginationInfo.totalRecordCount;
        this.list = response.data.list.map(item => {
          const rn = (this.totalCnt + 1) - item.RN;
          const checked = false;
          const seleteStatus = '';
          const newItem = {
            ...item,
            rn,
            checked,
            seleteStatus,
          };
          return newItem;
        });
      }).catch((error) => {
        console.log(error.data);
      });
    },
    handlePageChange(newPage) {
      this.pagingParam.pageIndex = newPage;
      this.pageIndex = newPage;
      this.getList();
    },
    async statusChange() {
      console.log('statusChange 호출됨');
      console.log('appNos:', this.appNos);
      console.log('changeStatus:', this.changeStatus);

      if (this.appNos === '') {
        alert('변경할 신청서를 선택해주세요.');
        return;
      }

      if (this.changeStatus === '') {
        alert('변경할 심사 상태 값을 선택해주세요.');
        return;
      }

      try {
        console.log('changeStatue 호출 전');
        const result = await changeStatue(this.appNos, this.changeStatus);
        console.log('changeStatue 결과:', result);

        if (result && result.success) {
          alert(result.message || '심사상태가 성공적으로 변경되었습니다.');
          this.getList();
        } else {
          alert('상태 변경에 실패했습니다.');
        }
      } catch (error) {
        console.error('심사상태 변경 오류:', error);
        alert(error.message || '심사상태 변경에 실패했습니다.');
      }
    },
    checkChange() {
      this.appNos = this.seletedItems.join(',');
      this.changeStatus = this.checkChangeStatus;
      this.statusChange();
    },
    oneChange(item) {
      console.log('oneChange 호출됨');
      console.log('item:', item);
      console.log('item.APP_NO:', item.APP_NO);
      console.log('item.seleteStatus:', item.seleteStatus);

      this.appNos = item.APP_NO;
      this.changeStatus = item.seleteStatus;
      this.statusChange();
    },
    showAppView(appNo) {
      $('body').addClass('modal-open');
      this.appViewModal = true;
      this.appNo = appNo;
    },
    showAnnPreView() {
      $('body').addClass('modal-open');
      this.annPreViewModal = true;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// MyCompAppRecannList.vue?125ad473